import React from 'react';

const LowerSection = (props) => {
    return (
        <>
            {props.filterDetails.search === "invoiceDetails" ?
                <div className="item-sections w-[100%]  ml-auto mt-3 !p-3  !bg-white rounded-[10px]"
                    style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                    <div className='flex gap-1.5'>
                        <div className="w-[13%]">
                            <label>{props.pageName === "gstSales" ? "Sales Amt" : "Purchase Amt."}</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="salesPurchaseAmount"
                                name="salesPurchaseAmount"
                                autocomplete="off"
                                disabled
                                value={props.filterDetails.salesPurchaseAmount}

                            />
                        </div>
                        <div className=" w-[8%]">
                            <label>Disc.</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="discount"
                                name="discount"
                                autocomplete="off"
                                disabled
                                value={Number(props.filterDetails.discount).toFixed(2)}

                            />
                        </div>

                        <div className="w-[12%]">
                            <label>SGST Amt.</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="sgstAmt"
                                name="sgstAmt"
                                autocomplete="off"
                                disabled
                                value={Number(props.filterDetails.sgstAmt).toFixed(2)}

                            />
                        </div>
                        <div className="w-[12%]">
                            <label>CGST Amt.</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="cgstAmt"
                                name="cgstAmt"
                                autocomplete="off"
                                disabled
                                value={Number(props.filterDetails.cgstAmt).toFixed(2)}

                            />
                        </div>
                        <div className="w-[12%]">
                            <label>IGST Amt.</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="igstAmt"
                                name="igstAmt"
                                autocomplete="off"
                                disabled
                                value={Number(props.filterDetails.igstAmt).toFixed(2)}

                            />
                        </div>
                        <div className="w-[10%]">
                            <label>Freight</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="freight"
                                name="freight"
                                autocomplete="off"
                                disabled
                                value={props.filterDetails.freight}

                            />
                        </div>
                        <div className="w-[10%]">
                            <label>Other</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="other"
                                name="other"
                                autocomplete="off"
                                disabled
                                value={Number(props.filterDetails.other).toFixed(2)}

                            />
                        </div>
                        <div className="w-[8%]">
                            <label>Rnd Off</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="roundOff"
                                name="roundOff"
                                autocomplete="off"
                                disabled
                                value={Number(props.filterDetails.roundOff).toFixed(2)}

                            />
                        </div>
                        <div className="w-[15%]">
                            <label>Net Amt.</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="netAmount"
                                name="netAmount"
                                autocomplete="off"
                                disabled
                                value={props.filterDetails.netAmount}

                            />
                        </div>
                    </div>



                </div>
                :
                props.filterDetails.search === "gstSummary" ?
                    <div className="item-sections w-[100%]  ml-auto mt-3 !p-3  !bg-white rounded-[4px]"
                        style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
                        <div className='flex gap-1.5'>

                            <div className=" w-[30%]">
                                <label>Total Taxable Amount</label>
                                <input
                                    className='h-[36px]'
                                    type="number"
                                    id="taxableAmount"
                                    name="taxableAmount"
                                    autocomplete="off"
                                    disabled
                                    value={props.filterDetails.taxableAmount}

                                />
                            </div>
                            <div className="w-[23%]">
                                <label>SGST Amount</label>
                                <input
                                    className='h-[36px]'
                                    type="number"
                                    id="sgstAmount"
                                    name="sgstAmount"
                                    autocomplete="off"
                                    disabled
                                    value={props.filterDetails.sgstAmount}

                                />
                            </div>
                            <div className="w-[23%]">
                                <label>CGST Amount</label>
                                <input
                                    className='h-[36px]'
                                    type="number"
                                    id="cgstAmount"
                                    name="cgstAmount"
                                    autocomplete="off"
                                    disabled
                                    value={props.filterDetails.cgstAmount}

                                />
                            </div>
                            <div className="w-[23%]">
                                <label>IGST Amount</label>
                                <input
                                    className='h-[36px]'
                                    type="number"
                                    id="igstAmount"
                                    name="igstAmount"
                                    autocomplete="off"
                                    disabled
                                    value={props.filterDetails.igstAmount}
                                />
                            </div>
                        </div>
                    </div>
                    :
                    null
            }
        </>
    );
};

export default LowerSection;